import {
	DATE_YMD,
	IS_EMPTY_LIST,
	IS_NOT_NULL_OR_UNDEFINED,
	TO_CENTS,
	TO_MOMENT,
	generateEquipmentFilterValue,
	FROM_UTC_TO_STRING,
} from 'cargo-chief-commons';
import {
	FIELDS_MAP,
	getNestedValue,
	NUMBER_FIELDS,
	STATE_FIELDS,
	LOAD_FIELDS,
	SERVER_FILTER_MAP,
} from '../carriers-loads-list/constants';
import { ParamMap } from '@angular/router';

const DATE_FORMAT = 'MM/DD/YYYY';
const FILTER_DATE_FORMAT = 'YYYY-MM-DD';

export const filterData = (loadsListCopy: any[], filtersList: any[]) => {
	let filteredLoads = loadsListCopy;
	if (filtersList) {
		return filteredLoads.filter((load) => {
			let result = true;
			for (let i = 0; i < filtersList.length; i++) {
				const { filterField, filterText, filterCondition, operator, startValue, endValue } =
					filtersList[i];
				const key = FIELDS_MAP[filterField];
				const fieldValue = Array.isArray(key) ? getNestedValue(load, key) : load[key];
				const isNumberField = NUMBER_FIELDS.has(filterField);
				const isEquipmentField = filterField === LOAD_FIELDS.EQUIPMENT;
				const isStateOrEquipmentField = STATE_FIELDS.has(filterField) || isEquipmentField;
				const isCompanyFilterField = filterField === LOAD_FIELDS.COMPANY;
				const filterTextFormatted =
					filterText && !isNumberField && !isStateOrEquipmentField && !isCompanyFilterField
						? filterText.toLowerCase()
						: filterText;
				const fieldValueFormatted =
					fieldValue && !isNumberField && !isStateOrEquipmentField
						? fieldValue.toLowerCase()
						: fieldValue;
				let comparisonResult = false;
				const isCurrencyField =
					filterField === LOAD_FIELDS.RATE || filterField === LOAD_FIELDS.OFFERED_RATE;
				const fieldValueConverted =
					isNumberField && IS_NOT_NULL_OR_UNDEFINED(fieldValue)
						? isCurrencyField
							? fieldValue / 100
							: fieldValue
						: 0;
				switch (operator) {
					case '=':
						if (isStateOrEquipmentField) {
							if (!Array.isArray(filterText)) {
								comparisonResult = false;
								break;
							}
							if (isEquipmentField) {
								comparisonResult = fieldValue.some((item) => filterText.includes(item));
							} else {
								comparisonResult = filterText.includes(
									IS_NOT_NULL_OR_UNDEFINED(fieldValue) ? fieldValue.toUpperCase() : fieldValue
								);
							}
						} else if (isCompanyFilterField) {
							comparisonResult = filterText.includes(load?.quoteDTO?.accountId);
						} else {
							comparisonResult = fieldValueFormatted === filterTextFormatted;
						}
						break;
					case '%':
						comparisonResult =
							fieldValueFormatted && fieldValueFormatted.includes(filterTextFormatted);
						break;
					case '!=':
						if (isStateOrEquipmentField) {
							if (!Array.isArray(filterText)) {
								comparisonResult = false;
								break;
							}
							if (isEquipmentField) {
								comparisonResult = !fieldValue.some((item) => filterText.includes(item));
							} else {
								comparisonResult = !filterText.includes(
									IS_NOT_NULL_OR_UNDEFINED(fieldValue) ? fieldValue.toUpperCase() : fieldValue
								);
							}
						} else if (isCompanyFilterField) {
							comparisonResult = !filterText.includes(load?.quoteDTO?.accountId);
						} else {
							comparisonResult = fieldValueFormatted !== filterTextFormatted;
						}
						break;
					case '>':
						comparisonResult = fieldValueConverted > filterText;
						break;
					case '>=':
						comparisonResult = fieldValueConverted >= filterText;
						break;
					case '<':
						comparisonResult = fieldValueConverted < filterText;
						break;
					case '<=':
						comparisonResult = fieldValueConverted <= filterText;
						break;
					case 'between':
						try {
							const startDate = TO_MOMENT(DATE_YMD(startValue.toJSON()), FILTER_DATE_FORMAT);
							const endDate = TO_MOMENT(DATE_YMD(endValue.toJSON()), FILTER_DATE_FORMAT);
							const loadDate = TO_MOMENT(fieldValue, DATE_FORMAT);
							comparisonResult = loadDate.isBetween(startDate, endDate, undefined, '[]');
						} catch (error) {
							console.error('Unable to filter by dates');
							comparisonResult = false;
						}
						break;
					default:
						comparisonResult = false;
				}

				if (i === 0) {
					result = comparisonResult;
				} else if (filterCondition === 'and') {
					result = result && comparisonResult;
				} else if (filterCondition === 'or') {
					result = result || comparisonResult;
				}
			}
			return result;
		});
	}
	return filteredLoads;
};

const parseValue = (filterField: string, value: any) => {
	const dateFields = [LOAD_FIELDS.PICKUP_DATE, LOAD_FIELDS.DELIVERY_DATE];
	if (filterField === LOAD_FIELDS.EQUIPMENT && value) {
		return generateEquipmentFilterValue(value);
	}
	if (dateFields.includes(filterField) && value) {
		return FROM_UTC_TO_STRING(value);
	}
	if (Array.isArray(value)) {
		return value.join(',');
	}
	if (filterField === LOAD_FIELDS.RATE) {
		return TO_CENTS(value);
	}
	return value;
};

export const parseOperator = (filterField: string, value: any) => {
	if (filterField == LOAD_FIELDS.COMPANY) {
		return '=';
	}
	return value;
};

export const mapFilterData = (filtersList: any[]): any[] => {
	if (IS_EMPTY_LIST(filtersList)) return [];
	return filtersList.map((filter) => ({
		field: SERVER_FILTER_MAP[filter.filterField],
		value: parseValue(filter.filterField, filter.filterText),
		condition: filter.filterCondition || 'and',
		operator: parseOperator(filter.filterField, filter.operator),
		startValue: parseValue(filter.filterField, filter.startValue),
		endValue: parseValue(filter.filterField, filter.endValue),
	}));
};

export const shouldExcludeDemoLoads = (
	isProductionSystem: boolean,
	queryParamMap: ParamMap
): boolean => {
	const demoQueryParam = queryParamMap.get('demo');
	return (
		isProductionSystem || (IS_NOT_NULL_OR_UNDEFINED(demoQueryParam) && demoQueryParam !== 'true')
	);
};
